<template>
  <div class="upload-container">
    <Upload
      multiple
      type="drag"
      :format="['jpg', 'png']"
      :before-upload="handleUpload"
      :on-format-error="handleFormatError"
      action=""
    >
      <div style="padding: 20px 0">
        <p>Click or drag files here to upload</p>
      </div>
    </Upload>
    <div class="imgList-wrapper">
      <div v-for="(item, index) in imgList" :key="index" class="imgList-item">
        <img :src="imgList[index]" alt="metamask48">
        <!-- <div class="key-wrapper">
          <p>
            属性：
            <span>值</span>
          </p>
          <img src="../../assets/img/changeName.svg" alt="changeName">
        </div> -->
      </div>
    </div>
    <div v-if="imgList.length > 0" class="confirm-wrapper">
      <button @click="upload">
        确认上传
      </button>
    </div>
    <div class="loading-warpper">
      <div v-if="isLoading" class="spin-container">
        <Spin fix size="large" />
      </div>
      <div v-else class="imgList-wrapper">
        <div
          v-for="(item, index) in uploadImageList"
          :key="index"
          class="imgList-item"
        >
          <img :src="item.image" :alt="`image[${index}]`">
          <div class="key-wrapper">
            <p>
              属性：
              <span>值</span>
            </p>
            <img src="../../assets/img/changeName.svg" alt="changeName">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchPost, fetchGet } from "@/common/utils/request.js";
import { mapState } from "vuex";
export default {
  name: "UploadImage",
  inject: ["reload"],
  data() {
    return {
      imgList: [],
      uploadImageList: [],
      isLoading: true,
    };
  },
  computed: {
    ...mapState(["ethAddress"]),
  },

  methods: {
    handleUpload(file) {
      //上传文件之前
      //读取文件的字符流
      const suffix = file.name.replace(/.+\./, ""); //取得文件的后缀名
      if (
        ["jpg", "JPG", "jpeg", "JPEG", "png", "PNG"].filter((x) => {
          return x == suffix;
        }).length == 0
      ) {
        console.log("文件格式错误");
        //清除文件
      }
      const reader = new FileReader();
      //将文件读取为 DataURL 以data:开头的字符串
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        // 读取到的图片base64 数据编码 将此编码字符串传给后台即可
        const code = e.target.result;
        // this.imgBase64 = code;
        this.imgList.push(code);
      };
      return false;
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select jpg or png.",
      });
    },

    // 上传图片
    async upload() {
      try {
        console.log(this.imgList);
        const params = {
          request: {
            address: this.ethAddress,
            base_64_images: this.imgList,
            project_id: this.$route.params.projectId,
          },
          signature: "oyc",
        };
        console.log({ params });
        const res = await fetchPost("/api/audit/uploadImages", params);
        if (res.data.code == 200) {
          this.$Notice.success({
            title: "Upload success !",
          });
          this.reload();
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 获取上传列表
    async getUploadList() {
      try {
        const res = await fetchGet(
          `/api/audit/getUploadedImages/${this.$route.params.projectId}`
        );
        console.log(res);
        this.uploadImageList = res.data.data;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.getUploadList();
  },
};
</script>

<style lang="less" scoped>
.upload-container {
  padding: 20px;
  .fileList-wrapper {
    border: 1px solid #fff;
    width: 100%;
    height: 200px;
    position: relative;
    cursor: pointer;
    p {
      color: #fff;
      font-size: 24px;
      line-height: 24px;
      height: 30px;
      width: 100%;
      text-align: center;
      position: absolute;
      left: 0;
      top: calc(50% - 15px);
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .spin-container {
    display: inline-block;
    width: 100%;
    height: 300px;
    position: relative;
  }
  .imgList-wrapper {
    margin-top: 20px;
    width: 100%;
    display: grid;
    grid-template-columns: 23.5% 23.5% 23.5% 23.5%;
    grid-row-gap: 20px;
    grid-column-gap: 2%;
    .imgList-item {
      img {
        width: 100%;
      }
      .key-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
        img {
          cursor: pointer;
          max-width: 20px;
          margin-left: 5px;
        }
      }
    }
  }
  .confirm-wrapper {
    margin-top: 50px;
    text-align: center;
    button {
      border: 1px solid #fff;
      width: 30%;
      height: 40px;
    }
  }
}
</style>
